/*
 * @Author: cc
 * @Date: 2021-03-29 09:46:57
 * @LastEditTime: 2021-03-29 16:37:45
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\manageConfig\productManageMent\television\service\createTelevision\createTelevision.js
 * @Description: 新建电视站点
 */
'use strict';
angular.module('createTelevisionModule', [])
    .controller('createTelevisionCtrl', ['$scope', 'tvBaseData', '$modalInstance', 'modalDialog', '$validation', '$q', 'trsHttpService', function($scope, tvBaseData, $modalInstance, modalDialog, $validation, $q, trsHttpService) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化状态]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                tvTitle: tvBaseData.isNew ? '新建电视' : '修改电视',
                siteId: tvBaseData.data ? tvBaseData.data.SITEID : '',
            };
            $scope.data = {
                tvName: '',
            };
        }

        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {
            if (!tvBaseData.isNew) {
                queryBySiteId();
            }
        }

        /**
         * [queryBySiteId 查询站点信息]
         * @return {[type]} [description]
         */
        function queryBySiteId(){
            var params = {
                serviceid: 'mlf_tvconfig',
                methodname: 'findWebSiteById',
                SiteId: $scope.status.siteId,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data){
                $scope.data.tvName = data.SITEDESC;
            });
        }

        /**
         * [close 关闭]
         * @return {[type]} [description]
         */
        $scope.close = function() {
            $modalInstance.dismiss();
        };

        /**
         * [submit 新增、修改提交操作]
         * @return {[type]} [description]
         */
        function submit() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_tvconfig',
                methodname: 'saveNewSite',
                ObjectId: tvBaseData.isNew ? '0' : tvBaseData.data.SITEID,
                SiteName: $scope.data.tvName,
                SiteDesc: $scope.data.tvName,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('提交成功', '', 'success', false, function() {
                    defer.resolve();
                    $modalInstance.close('success');
                });
            });
            return defer.promise;
        }

        /**
         * [confirm 确定]
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            $validation.validate($scope.createTelevisionFrom).success(function(flag) {
                submit();
            }).error(function() {
                modalDialog.alertType('提交失败', '请检查表单', 'info', false, function() {});
            });

        };
    }]);
